(() => {
  const drawer = document.getElementById('sidebar-mobile-nav');
  const host = drawer && drawer.querySelector('.block-mobile-nav');
  if (!host || host.dataset.bsSourceReady) return;
  host.dataset.bsSourceReady = 'true';
  let signature = '';
  // Match collection handles, so translated labels do not change the icon.
  const categoryPaths = {
    'all-showers': 'M8 38V6h28v32H8Zm18-32v32M12 34h20M29 19v6M12 10h9M18 10v4m-4 4v2m4-2v2m4-2v2',
    'furniture-basins': 'M7 20h30l-4 7H11l-4-7Zm4 7v12h22V27M22 27v12M16 31h2m8 0h2M22 20V10a4 4 0 0 1 8 0v2M27 12h6',
    toilets: 'M8 7h10v18H8V7Zm3 5h4M18 21h20v4H18M12 25h24c0 7-4 10-11 10H15l-3-10Zm5 10-2 5h16l-2-6',
    baths: 'M5 22h34M8 22l3 12h22l3-12M13 34l-2 5m20-5 2 5M10 22V10a4 4 0 0 1 8 0v2M15 12h6',
    taps: 'M12 38V18a10 10 0 0 1 20 0v5h-7v-5a3 3 0 0 0-6 0v20M8 38h16M19 28h9m-2-4v8M28 27h5m-5 3h5',
    'bathroom-accessories': 'M6 12h32M9 9v6m26-6v6M13 12v25h18V12M17 32h10M17 16v11',
    kitchen: 'M5 20h34M8 20v18h28V20M13 20v3a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-3M22 31v7M18 34v1m8-1v1M20 20h4M22 20V11a4 4 0 0 1 8 0v4',
    tiles: 'M7 7h13v13H7V7Zm17 0h13v13H24V7ZM7 24h13v13H7V24Zm17 0h13v13H24V24Z'
  };
  const categoryIcon = link => {
    const handle = new URL(link.href, document.baseURI).pathname.replace(/\/$/, '').split('/').pop();
    const pathData = categoryPaths[handle];
    if (!pathData) return null;
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    Object.entries({ class: 'bs-menu-category-icon', viewBox: '0 0 44 44', width: '32', height: '32',
      fill: 'none', stroke: 'currentColor', 'stroke-width': '1.7', 'stroke-linecap': 'round',
      'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false' }).forEach(([name, value]) => svg.setAttribute(name, value));
    const path = document.createElementNS(ns, 'path');
    path.setAttribute('d', pathData);
    svg.appendChild(path);
    return svg;
  };
  const label = link => (link.getAttribute('title') || link.getAttribute('aria-label') ||
    link.querySelector('.mega-nav__promo-cta')?.textContent || link.textContent ||
    link.querySelector('img')?.alt || '').trim();
  const copyLink = (original, className) => {
    const link = document.createElement('a');
    link.className = className;
    link.textContent = label(original);
    link.setAttribute('href', original.getAttribute('href'));
    ['target', 'rel', 'aria-current'].forEach(name => {
      if (original.hasAttribute(name)) link.setAttribute(name, original.getAttribute(name));
    });
    const sourceSwatch = original.querySelector('.mega-nav__swatch');
    if (sourceSwatch) {
      const swatch = document.createElement('span');
      swatch.className = 'bs-menu-swatch';
      swatch.style.background = sourceSwatch.style.background;
      swatch.setAttribute('aria-hidden', 'true');
      link.classList.add('bs-menu-finish');
      link.prepend(swatch);
    }
    if (original.classList.contains('mega-nav__size')) {
      link.classList.add('bs-menu-size');
      link.textContent = original.textContent.trim();
      link.setAttribute('aria-label', label(original));
    }
    return link;
  };
  const rebuild = () => {
    const source = document.querySelector('.header--desktop [data-bs-navigation-source]');
    const items = source && [...source.querySelectorAll('.main-nav__list > .nav__item')];
    if (!items || !items.length) return;
    const nextSignature = items.map(item => item.innerHTML).join('');
    if (nextSignature === signature) return;
    const nav = document.createElement('nav');
    nav.className = 'mobile-nav w100';
    nav.dataset.bsMirroredNavigation = 'true';
    const list = document.createElement('ul');
    list.className = 'mobile-nav__list';
    items.forEach((item, index) => {
      const original = item.querySelector(':scope > .nav__item__link');
      if (!original) return;
      const li = document.createElement('li');
      li.className = 'mobile-nav__item mobile-nav__item--level1';
      const row = document.createElement('div');
      row.className = 'mobile-nav__top-link-wrap flex flex-align-ver w100 flex-align-space-between';
      const topLink = copyLink(original, 'mobile-nav__item__top-link');
      const icon = categoryIcon(original);
      if (icon) topLink.prepend(icon);
      row.appendChild(topLink);
      li.appendChild(row);
      const dropdown = item.querySelector(':scope > .nav__item__dropdown');
      if (dropdown && dropdown.querySelector('a[href]')) {
        const panel = document.createElement('div');
        panel.id = 'bs-desktop-menu-panel-' + index;
        panel.className = 'mobile-nav__children';
        panel.style.display = 'none';
        const used = new Set();
        dropdown.querySelectorAll('.mega-nav__all').forEach(link => {
          panel.appendChild(copyLink(link, 'mobile-nav__level3 bs-menu-shop-all'));
          used.add(link);
        });
        dropdown.querySelectorAll('.mega-nav__col,.mega-nav__extras,.nav__item__column').forEach(column => {
          const links = [...column.querySelectorAll('a[href]')].filter(link => !used.has(link));
          if (!links.length) return;
          const heading = column.querySelector('.mega-nav__heading,.mega-nav__extras-label,.nav__item__dropdown-title');
          let group = panel;
          if (heading && heading.textContent.trim()) {
            group = document.createElement('details');
            group.className = 'bs-menu-group';
            const summary = document.createElement('summary');
            summary.textContent = heading.textContent.trim();
            group.appendChild(summary);
            panel.appendChild(group);
          }
          const body = document.createElement('div');
          body.className = 'bs-menu-group__body';
          if (links.every(link => link.classList.contains('mega-nav__size'))) body.classList.add('bs-menu-sizes');
          links.forEach(link => { body.appendChild(copyLink(link, 'mobile-nav__level3')); used.add(link); });
          group.appendChild(body);
        });
        dropdown.querySelectorAll('a[href]').forEach(link => {
          if (!used.has(link)) panel.appendChild(copyLink(link, 'mobile-nav__level3'));
        });
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mobile-nav__arrow flex flex-align-ver flex-align-hoz';
        button.textContent = '+';
        button.setAttribute('aria-label', (drawer.dataset.submenuLabel || '__TITLE__').replace('__TITLE__', label(original)));
        button.setAttribute('aria-controls', panel.id);
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', event => {
          event.stopPropagation();
          const open = !li.classList.contains('open');
          li.classList.toggle('open', open);
          panel.style.display = open ? 'block' : 'none';
          panel.inert = !open;
          panel.setAttribute('aria-hidden', String(!open));
          button.setAttribute('aria-expanded', String(open));
          button.textContent = open ? '−' : '+';
        });
        row.appendChild(button);
        li.appendChild(panel);
      }
      list.appendChild(li);
    });
    if (!list.children.length) return;
    nav.appendChild(list);
    host.replaceChildren(nav);
    signature = nextSignature;
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-target="#sidebar-mobile-nav"]')) rebuild();
  }, true);
  document.addEventListener('shopify:section:load', rebuild);
  rebuild();
})();
